import { useState } from "react";
import { DIFFICULTY_ORDER, DIFFICULTY_MODES } from "../game/constants/difficulty";
import { Button } from "./Button";

const percent = (value) => `${Math.round(value * 100)}%`;

export function SettingsPanel({ settings, onChange, onClose = null, identity = null, account = null }) {
	const [tab, setTab] = useState("general");
	const update = (patch) => onChange({ ...settings, ...patch });

	return (
		<section className="panel settings-panel">
			<div className="panel__heading">
				<div>
					<div className="eyebrow">Settings</div>
					<h2>Command Console</h2>
				</div>
				{onClose && <Button tone="ghost" onClick={onClose}>Close</Button>}
			</div>
			<div className="settings-tabs" role="tablist" aria-label="Settings sections">
				<button type="button" className={tab === "general" ? "is-active" : ""} onClick={() => setTab("general")}>General</button>
				{identity && <button type="button" className={tab === "identity" ? "is-active" : ""} onClick={() => setTab("identity")}>Identity</button>}
			</div>

			{tab === "general" && (
				<>
					<div className="settings-grid">
						<label className="toggle-row">
							<span>Sound Effects</span>
							<input type="checkbox" checked={settings.sfx} onChange={(event) => update({ sfx: event.target.checked, sound: event.target.checked })} />
						</label>
						<label className="slider-row">
							<span>SFX Volume <strong>{percent(settings.sfxVolume)}</strong></span>
							<input
								type="range"
								min="0"
								max="1"
								step="0.05"
								value={settings.sfxVolume}
								style={{ "--fill": percent(settings.sfxVolume) }}
								disabled={!settings.sfx}
								onChange={(event) => update({ sfxVolume: Number(event.target.value) })}
							/>
						</label>
						<label className="toggle-row">
							<span>Music</span>
							<input type="checkbox" checked={settings.music} onChange={(event) => update({ music: event.target.checked })} />
						</label>
						<label className="slider-row">
							<span>Music Volume <strong>{percent(settings.musicVolume)}</strong></span>
							<input
								type="range"
								min="0"
								max="1"
								step="0.05"
								value={settings.musicVolume}
								style={{ "--fill": percent(settings.musicVolume) }}
								disabled={!settings.music}
								onChange={(event) => update({ musicVolume: Number(event.target.value) })}
							/>
						</label>
						<label className="toggle-row">
							<span>Performance Mode</span>
							<input type="checkbox" checked={settings.performanceMode} onChange={(event) => update({ performanceMode: event.target.checked })} />
						</label>
						<label className="toggle-row">
							<span>Mobile Haptics</span>
							<input type="checkbox" checked={settings.vibration} onChange={(event) => update({ vibration: event.target.checked })} />
						</label>
					</div>
					<div className="segmented">
						{["low", "normal", "high"].map((value) => (
							<Button key={value} tone={settings.effectsIntensity === value ? "primary" : "ghost"} onClick={() => update({ effectsIntensity: value })}>
								{value}
							</Button>
						))}
					</div>
					<div className="settings-subgroup">
						<span>Difficulty</span>
						<div className="segmented">
							{DIFFICULTY_ORDER.map((value) => (
								<Button key={value} tone={settings.difficultyMode === value ? "primary" : "ghost"} onClick={() => update({ difficultyMode: value })}>
									{DIFFICULTY_MODES[value].label}
								</Button>
							))}
						</div>
					</div>
				</>
			)}

			{tab === "identity" && identity && (
				<div className="settings-grid identity-tab">
					<label className="profile-panel__label">
						<span>Username</span>
						<div className="username-row">
							<input
								value={identity.usernameInput}
								onChange={(event) => identity.setUsernameInput(event.target.value)}
								type="text"
								placeholder="SpicyCactus816"
								autoComplete="nickname"
								maxLength={20}
								disabled={identity.disabled}
							/>
							<Button type="button" tone="ghost" onClick={identity.onRandomize} disabled={identity.disabled}>Random</Button>
						</div>
					</label>
					<p className={`field-status field-status--${identity.status.tone}`}>{identity.status.message}</p>
					<div className="profile-panel__actions">
						<Button tone="primary" onClick={identity.onSave} disabled={identity.saveDisabled}>
							{identity.saving ? "Saving..." : "Save Username"}
						</Button>
						<span>Command Marks: {identity.commandMarks}</span>
					</div>
				</div>
			)}

			<div className="account-links">
				{account?.onLogout && (
					<Button tone="ghost" onClick={account.onLogout}>
						Log Out
					</Button>
				)}
				<a className="button button--ghost" href="/account-deletion/" target="_blank" rel="noopener">
					Request account deletion
				</a>
				<a href="/privacy/" target="_blank" rel="noopener">
					Privacy policy
				</a>
			</div>
		</section>
	);
}
